import { models, fa } from "app/main/std";
import * as React from "react";
import * as resources from "app/resources/index";
import { createSelectorRx } from "keautils";
import { observeResource } from "kea-resource";
import { columnas } from "./columns";
import * as kea from "kea-react";
import { FiltroBitacoraComponent } from "./filtro";
import * as history from "app/main/history";
import { componentToRx } from "react-rxk";
import { AgregarButton, message } from "kea-react";
import { ObservacionesModal } from "./observaciones";
import { DetalleModal } from "./detalle";
import { BitacoraRAD } from "app/resources/index";

interface Props {
    filtro: models.BitacoraRADFiltro;
    onFiltroChange: (x: models.BitacoraRADFiltro) => void;
}

const resource = resources.BitacoraRAD;
type Entity = models.BitacoraRADDto;

class BitacoraRADListNoRx extends React.PureComponent<Props> {
    modalManager = kea.createModalManager();
    private modals = kea.createModalManager();
    private filtro = (props: Props) => props.filtro;
    private observable = createSelectorRx(this.filtro, filtro => {
        const obs = observeResource(resource.Query, filtro);
        return obs;
    });

    onRegresar = () => history.go("../");
    onAgregar = () => history.go("./new");

    onStatus = (x: Entity) => history.go("./status/" + x.IdRegistro);
    onVer = (x: Entity) => history.go("./" + x.IdRegistro);

    onAceptar = async (x: Entity) => {
        if(x.Status != models.StatusBitacoraRad.Pendiente) {
            message("Status inválido", "El registro debe de estar en status pendiente");
            return;
        }

        const result = await this.modalManager.showModal(ObservacionesModal, "Finalizar", "");
        if (!result.result)
            return;

        await BitacoraRAD.CambiarStatus(x.IdRegistro!, models.StatusBitacoraRad.Listo, result.value);
    }

    onVerModal = (x:Entity) =>
    {
        this.modalManager.showModal(DetalleModal, undefined, x);
        //console.log(x);
    }

    onCancelar = async (x: Entity) => {
        if(x.Status != models.StatusBitacoraRad.Pendiente) {
            message("Status inválido", "El registro debe de estar en status pendiente");
            return;
        }

        const result = await this.modalManager.showModal(ObservacionesModal, "Cancelar", "");
        if (!result.result)
            return;

        await BitacoraRAD.CambiarStatus(x.IdRegistro!, models.StatusBitacoraRad.Cancelada, result.value);
    }

    limpiarfiltros = (x: Props) => {
        
        x.filtro.Limite = null;
        x.filtro.Status = null;
        x.filtro.FechaMax = null;
        x.filtro.FechaMin = null;
        x.filtro.IdSucursal = null;
        x.filtro.IdSucursalRecoleccion = null;
        x.filtro.UsuarioCreador = null;
        location.reload();
    };

    render() {
        const cols = columnas(this);
        const observable = this.observable(this.props);
        const filtro = this.filtro(this.props);

        return (
            <div>
                <kea.Title titulo="Bitácora de Recolección a Domicilio" onRegresar={this.onRegresar}>
                    <kea.Button children="Limpiar campos" style="default" onClick={() => this.limpiarfiltros(this.props)} />
                    <kea.Button iconClass={fa("file-excel-o")} onClick={() => history.go("./reporte")}>
                        Eficiencia de RAD
                    </kea.Button>
                    <AgregarButton onClick={this.onAgregar} />
                </kea.Title>

                <FiltroBitacoraComponent value={filtro} onChange={this.props.onFiltroChange} />
                
                <kea.Grid2 columnas={cols} cookieKey={"BitacoraRADListKey"} items={observable} />
                {this.modalManager.component}
            </div>
        );
    }
}

const BitacoraRADListRx = componentToRx(BitacoraRADListNoRx);

export class BitacoraRADList extends React.PureComponent<{}, { filtro: models.BitacoraRADFiltro }> {

    constructor(props: Props) {
        super(props);
        this.state = {
            filtro: {}
        };
    }
    onChange = (filtro: models.BitacoraRADFiltro) => this.setState({ filtro });
   

    render() {
        return (
            <BitacoraRADListRx
                filtro={this.state.filtro}
                onFiltroChange={this.onChange}
            />
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/bitacoraRAD/list/list.tsx